import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=1a2c3ada&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=ts&setup=true"
export * from "./Metrics.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=1a2c3ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c3ada",
  null
  
)

/* custom blocks */
import block0 from "./Metrics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,Term: require('/home/runner/work/assessment-service/assessment-service/frontend/components/Term.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,MetricsCellsMetricName: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/cells/MetricName.vue').default,IxKpiEdit: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/kpiEdit.vue').default,IxButtonWhite: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/White.vue').default})
